/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useContext,
  useCallback,
  useMemo,
  useReducer,
  useEffect
} from "react";
import { useHistory } from "react-router-dom";

import Sidebar from "./Sidebar";
import Header from "./Header";
import Transition from "App/common/ui/Transition";
import { SLIDING_POPUPS, TRANSITION_CLASSESS } from "App/componentsConfig";
import { useHotKeys } from "App/common/hooks/hotKeys";
import { LayoutContext } from "App/common/hoc/Layout";
import Popup from "./Popup";
import { slidingPopupReducer } from "App/common/reducer";
import Notify from "App/common/ui/Notify";

export const SPopupContext = React.createContext({
  sPopupState: {},
  sPopupMethods: {}
});

function SlidingPopup(props) {
  const history = useHistory();
  const { lState, lMethods } = useContext(LayoutContext);
  const sPopup = lState.slidingPopup;
  const initialState = useMemo(
    () => ({
      currentTab: sPopup.tab,
      params: null,
      notify: { show: false, params: null },
      popup: { show: false, alertName: "", params: null },
      refresh: { show: false, fetch: null },
      validation: { status: true, msg: "", params: {} },
      disableClose: { close: true, params: {} }
    }),
    []
  );
  const [sPopupState, dispatch] = useReducer(slidingPopupReducer, initialState);
  const sPopupMethods = useMemo(
    () => ({
      switchTab: tab => dispatch({ type: "SWITCH_TAB", tab: tab }),
      openPopup: (alertName, params) =>
        dispatch({ type: "OPEN_POPUP", alertName: alertName, params: params }),
      closePopup: () => dispatch({ type: "CLOSE_POPUP" }),
      showNotify: params => dispatch({ type: "SHOW_NOTIFY", params }),
      closeNotify: () => dispatch({ type: "CLOSE_NOTIFY" }),
      showValidation: obj => dispatch({ type: "SHOW_VALIDATION", obj }),
      closeValidation: () => dispatch({ type: "CLOSE_VALIDATION" }),
      showRefresh: fetch => dispatch({ type: "SHOW_REFRESH", fetch }),
      closeRefresh: () => dispatch({ type: "CLOSE_REFRESH" }),
      disableClose: (close, params) =>
        dispatch({ type: "DISABLE_CLOSE", close: close, params: params }),
      disablePopupConfirm: disable =>
        dispatch({ type: "DISABLE_POPUP_CONFIRM", disable: disable }),
      disableLeftFooter: disable =>
        dispatch({ type: "DISABLE_LEFT_FOOTER", disable: disable })
    }),
    []
  );

  const popupArr = SLIDING_POPUPS[sPopup.alertName];
  const tabPanel = popupArr.find(val => val.key === sPopupState.currentTab);

  useHotKeys(
    "esc",
    e => {
      e.preventDefault();
      if (sPopupState.popup.show) {
        sPopupMethods.closePopup();
      } else {
        closeSlidingPopup();
      }
    },
    [sPopupState]
  );

  const selectTabHandler = useCallback(
    tab => {
      if (tab !== sPopupState.currentTab) {
        if (!sPopupState.disableClose.close) {
          if (
            sPopupState.disableClose.params.display(() =>
              sPopupMethods.switchTab(tab)
            )
          ) {
            props.switchPanel("summary");
          }
        } else sPopupMethods.switchTab(tab);
      }
    },
    [sPopupState]
  );

  function closeSlidingPopup() {
    if (!sPopupState.disableClose.close) {
      sPopupState.disableClose.params.display("layout");
    } else {
      lMethods.closeSlidingPopup();
    }
  }

  useEffect(() => {
    history.listen(location => {
      closeSlidingPopup();
    });
  }, [history]);

  return (
    <SPopupContext.Provider value={{ sPopupState, sPopupMethods }}>
      <div
        className={[
          "main_slider",
          tabPanel.noSideBarSlider ? tabPanel.cssClass : ""
        ].join(" ")}
      >
        <div className={props.shadowClassess} onClick={closeSlidingPopup}></div>

        <div className={props.componentClassess}>
          <div className="slider_wrapper__inner">
            {!tabPanel.noSideBarSlider &&
            lState.slidingPopup.alertName === "virtualMachine" ? (
              <Sidebar close={lMethods.closeSlidingPopup} />
            ) : (
              !tabPanel.noSideBarSlider && (
                <Sidebar
                  close={closeSlidingPopup}
                  tabs={popupArr}
                  selectTab={selectTabHandler}
                  currentTab={sPopupState.currentTab}
                />
              )
            )}

            <div
              className={[
                "slider_container",
                sPopupState.notify.show || sPopupState.refresh.show
                  ? "notify_slider"
                  : ""
              ].join(" ")}
            >
              <Header
                title={tabPanel.title}
                name={
                  lState.slidingPopup.params
                    ? lState.slidingPopup.params.name
                    : null
                }
                currentTab={sPopupState.currentTab}
                openPopup={sPopupMethods.openPopup}
                clientUUID={
                  lState.slidingPopup.params
                    ? lState.slidingPopup.params.clientUUID
                    : null
                }
                toolTip={tabPanel && tabPanel.toolTip ? tabPanel.toolTip : null}
                isClose={tabPanel.noSideBarSlider}
                closeSlider={closeSlidingPopup}
              />
              {(sPopupState.notify.show || sPopupState.refresh.show) && (
                <Notify
                  notify={sPopupState.notify}
                  refresh={sPopupState.refresh}
                  closeNotify={sPopupMethods.closeNotify}
                  closeRefresh={sPopupMethods.closeRefresh}
                />
              )}

              {tabPanel.noSideBarSlider ? (
                <React.Fragment>
                  {React.createElement(tabPanel.component)}
                </React.Fragment>
              ) : (
                <div
                  className={[
                    "slider_content",
                    "is_relative",
                    sPopupState.notify.show || sPopupState.refresh.show
                      ? "notify_height"
                      : ""
                  ].join(" ")}
                >
                  {React.createElement(tabPanel.component)}
                </div>
              )}
            </div>
          </div>

          <Transition
            {...{
              show: sPopupState.popup.show,
              ...TRANSITION_CLASSESS.slidingPopup.popup
            }}
          >
            <Popup />
          </Transition>
        </div>
      </div>
    </SPopupContext.Provider>
  );
}

export default SlidingPopup;
